import SVG from "../core/SVG";

const FeedPostDropDown = () => {
    return (
        <div className="dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger">
            <div>
                <div className="button is-rounded">
                    <SVG
                        svg="more-vertical"
                        size={20}
                        className="light-grey-svg"
                    />
                </div>
            </div>
            <div className="dropdown-menu" role="menu">
                <div className="dropdown-content">
                    {/* <hr className="dropdown-divider" /> */}

                    {/* <hr className="dropdown-divider" /> */}

                    <a href="#" className="dropdown-item">
                        <div className="media d-flex flex-j-start flex-a-center gap-10">
                            <SVG
                                svg="hide-pswd"
                                size={18}
                                className="light-grey-svg"
                            />
                            <div className="media-content">
                                <h3>Hide post</h3>
                            </div>
                        </div>
                    </a>
                    <a href="#" className="dropdown-item">
                        <div className="media d-flex flex-j-start flex-a-center gap-10">
                            <SVG
                                svg="hide-pswd"
                                size={18}
                                className="light-grey-svg"
                            />
                            <div className="media-content">
                                <h3>Hide all posts by user</h3>
                            </div>
                        </div>
                    </a>
                    <a href="#" className="dropdown-item">
                        <div className="media d-flex flex-j-start flex-a-center gap-10">
                            <SVG
                                svg="flag"
                                size={18}
                                className="light-grey-svg"
                            />
                            <div className="media-content">
                                <h3>Report post</h3>
                            </div>
                        </div>
                    </a>
                    <a href="#" className="dropdown-item">
                        <div className="media d-flex flex-j-start flex-a-center gap-10">
                            <SVG
                                svg="user-minus"
                                size={18}
                                className="light-grey-svg"
                            />
                            <div className="media-content">
                                <h3>Unfollow user</h3>
                            </div>
                        </div>
                    </a>

                    <a href="#" className="dropdown-item">
                        <div className="media d-flex flex-j-start flex-a-center gap-10">
                            <SVG
                                svg="slash"
                                size={18}
                                className="light-grey-svg"
                            />
                            <div className="media-content">
                                <h3>Block user</h3>
                            </div>
                        </div>
                    </a>

                    {/* <hr className="dropdown-divider" /> */}

                    {/* <a className="dropdown-item">
                        <div className="media d-flex flex-j-start flex-a-center gap-10">
                            <SVG
                                svg="bell"
                                size={18}
                                className="light-grey-svg"
                            />
                            <div className="media-content">
                                <h3>Notify me</h3>
                                <small>Send me the updates.</small>
                            </div>
                        </div>
                    </a>
                    <a href="#" className="dropdown-item">
                        <div className="media d-flex flex-j-start flex-a-center gap-10">
                            <SVG
                                svg="flag"
                                size={18}
                                className="light-grey-svg"
                            />
                            <div className="media-content">
                                <h3>Flag</h3>
                                <small>In case of inappropriate content.</small>
                            </div>
                        </div>
                    </a> */}
                </div>
            </div>
        </div>
    );
};

export default FeedPostDropDown;
